// extracted by mini-css-extract-plugin
module.exports = {"slide":"Slider_slide__1WVpa","intro":"Slider_intro__tra-r"};